import { render, staticRenderFns } from "./SettingsStageRounds.vue?vue&type=template&id=2580152f&"
import script from "./SettingsStageRounds.vue?vue&type=script&lang=js&"
export * from "./SettingsStageRounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports